import { ParseError } from "@/repositories/shared/errors/parseError";
import {
  HttpEmailDomain,
  HttpEmailDomainInfo,
  IEmailDomainInfoParser,
} from "../userRepository.types";
import { ok, err, Result } from "neverthrow";
import { IEmailDomain, IEmailDomainInfo } from "@/domain/entities/user";
import { injectable } from "inversify";
import { EmailDomainInfo } from "@/domain/entities/user/emailDomaininfo";

function parseEmailDomain(data: HttpEmailDomain): IEmailDomain {
  const domain: IEmailDomain = {
    uid: data.uid,
    name: data.name,
    emailDomain: data.emailDomain,
    clientGroupCodeUid: data.clientGroupCodeUid,
    clientGroupName: data.clientGroupName,
  };
  return domain;
}

@injectable()
export class EmailDomainInfoParser implements IEmailDomainInfoParser {
  constructor() {}

  toDomain(data: HttpEmailDomainInfo): Result<IEmailDomainInfo, ParseError> {
    try {
      const emailDomaininfoData: IEmailDomainInfo = {
        emainlDomain: data.emailDomain,
        domains: data.companies.map(parseEmailDomain),
      };
      const emailDomaininfo = new EmailDomainInfo(emailDomaininfoData);
      return ok(emailDomaininfo);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
